module.exports = __webpack_public_path__ + "img/v1.6.01a5e120.jpg";